import { render, staticRenderFns } from "./Horas.vue?vue&type=template&id=6f1bfcf9&scoped=true&"
import script from "./Horas.vue?vue&type=script&lang=js&"
export * from "./Horas.vue?vue&type=script&lang=js&"
import style0 from "./Horas.vue?vue&type=style&index=0&id=6f1bfcf9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1bfcf9",
  null
  
)

export default component.exports